import styled, { css } from 'styled-components'
import { colors } from '../../styles/constants'

export const Top = styled.div`
  flex-basis: 100%;
  ${({ marginBottom }) => marginBottom ? `margin-bottom: ${marginBottom};` : 'margin-bottom: 16px;'}

  ${({ isFloating }) => isFloating && css`
    width: 100%;
    position: fixed;
    bottom: 64px;
    margin-bottom: 0;
    background-color: ${colors.white};
    z-index: 999;
    transition: .3s;
    transition-timing-function: cubic-bezier(.25, .1, .25, 1);
  `}
`

export const BackButton = styled.div`
  display: flex;
  gap: 12.67px;
  align-items: center;
  cursor: pointer;
  ${({ marginButton }) => marginButton ? `margin: ${marginButton};` : 'margin: 16px 28.67px;'}
  margin: ${({ noMargin }) => noMargin ? '0px' : '16px 28.67px'};
  height: 32px;
  ${({ colorButton }) => colorButton ? `color: ${colorButton};` : `color: ${colors.cyan.medium};`}
  letter-spacing: 0.96px;
  font-weight: 600;
  line-height: 19px;
  font-family: 'Open Sans';

  ${({ outline }) => outline && css`
    height: 50px;
    border: 1px solid ${colors.cyan.default};
    border-radius: 8px;
    font-weight: 700;
    justify-content: center;
  `}
`
